export const ROUTE_INDEX = '/'

export default {
  index: ROUTE_INDEX,
}
